import { Controller } from "@hotwired/stimulus"
const csrf = () => document.querySelector('meta[name="csrf-token"]')?.content

// Библиотека лекал: фильтр по рубрике (с учётом вложенных), поиск по названию и
// окно «Новое лекало». Правка самих рубрик живёт в окне «Рубрики» — обычными
// формами, поэтому здесь от неё ничего не осталось.
// Разметка панели/каталога (targets) наполняется партиалами _rubric_panel/_catalog.
export default class extends Controller {
  static targets = ["rubricRow", "card", "section", "search", "panel", "emptySearch", "newLekaloModal", "newRubricSelect"]

  // Модалка «Новое изделие» (замена страницы /lekalos/new). openNew из кнопок «+ Изделие»
  // и «+ изделие сюда» (data-rubric-id предвыбирает рубрику секции).
  openNew(e) {
    const rid = e?.currentTarget?.dataset?.rubricId
    if (rid && this.hasNewRubricSelectTarget) this.newRubricSelectTarget.value = rid
    this._open(this.newLekaloModalTarget)
  }
  closeNew() { if (this.hasNewLekaloModalTarget) this._hide(this.newLekaloModalTarget) }
  backdrop(e) { if (e.target === e.currentTarget) this._hide(e.currentTarget) }
  _open(m) { m.classList.remove("hidden"); m.classList.add("flex"); this._esc = (e) => { if (e.key === "Escape") this.closeNew() }; document.addEventListener("keydown", this._esc) }
  _hide(m) { m.classList.add("hidden"); m.classList.remove("flex"); if (this._esc) document.removeEventListener("keydown", this._esc) }

  filter(e) {
    this._activeId = e.currentTarget.dataset.rubricId || "all"
    // Ветка, а не одна рубрика: выбрав «Трикотаж», ждут увидеть и «Поло», и
    // «Классические», иначе у родителя каталог выглядит пустым.
    this._activeBranch = (e.currentTarget.dataset.branch || "").split(",").filter(Boolean)
    for (const row of this.rubricRowTargets) row.classList.toggle("active", (row.dataset.rubricId || "all") === this._activeId)
    this.apply()
  }

  // Перенос рубрики по дереву: «вынести» к деду или «вложить» под соседа сверху.

  search() { this.apply() }

  // Единый проход видимости (только style.display, без атрибута hidden — иначе display-класс секции
  // перебивал бы [hidden]). Карточки — по поиску; секции — по фильтру рубрики И наличию видимых карточек
  // (пустые рубрики видны без поиска, скрыты при поиске).
  apply() {
    const q = (this.hasSearchTarget ? this.searchTarget.value : "").trim().toLowerCase()
    const activeId = this._activeId || "all"
    for (const c of this.cardTargets) c.style.display = q !== "" && !(c.dataset.name || "").includes(q) ? "none" : ""
    let anyVisible = false
    for (const sec of this.sectionTargets) {
      const branch = this._activeBranch || []
      const inFilter = activeId === "all" ||
        (branch.length ? branch.includes(sec.dataset.rubricId) : sec.dataset.rubricId === activeId)
      const hasVisibleCard = Array.from(sec.querySelectorAll("[data-lekalos-target=card]")).some((c) => c.style.display !== "none")
      const visible = inFilter && (q === "" || hasVisibleCard)
      sec.style.display = visible ? "" : "none"
      if (visible) anyVisible = true
    }
    if (this.hasEmptySearchTarget) this.emptySearchTarget.hidden = !(q !== "" && !anyVisible)
  }



}
